import { useQuery } from "@connectrpc/connect-query";

import { adminListAccounts } from "@/gen/nodebase/v1/admin-AdminService_connectquery";

// useIsAdmin asks the server rather than inspecting the session, because being
// an admin is not a property of the credential: it is membership of
// NODEBASE_ADMIN_EMAILS, checked server-side on every admin RPC (requireAdmin).
// So the only honest client-side test is to try an admin call and see.
//
// This hides the entrance; it does not guard the door. Every /admin panel below
// still calls the server and still gets refused. Treat the result as a courtesy
// to the operator, never as an authorization decision.
export function useIsAdmin(): { isAdmin: boolean; settled: boolean } {
  const probe = useQuery(
    adminListAccounts,
    {},
    {
      // A refusal is the answer, not a failure to retry, and it will not change
      // within a session.
      retry: false,
      staleTime: 5 * 60_000,
    },
  );
  return { isAdmin: probe.isSuccess, settled: !probe.isPending };
}
export const ADMIN_REFRESH_MS = 5_000;
